(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sleeknote-popup"] && !Shopify.designMode) return;
  try {
    class SleeknotePopup extends HTMLElement {
  constructor() {
    super();
    
    this.liquidEligible = this.dataset.liquidEligible;
    this.campaignCodeCheck = this.dataset.campaignCodeCheck;
    this.bundleBadgeCheck = this.dataset.bundleBadgeCheck;
    this.disallowedUtmValues = this.dataset.disallowedUtmValues;
    this.delay = this.dataset.delay;
    this.sleeknoteId = this.dataset.sleeknoteId;
    this.limitPerSession = parseInt(this.dataset.limitPerSession);
    
    try {
      this.disallowedUtmValues = JSON.parse(this.disallowedUtmValues);
    } catch (err) {
      this.disallowedUtmValues = [this.disallowedUtmValues];
    }    
  }
  
  connectedCallback() {    
    this.triggeredCount = parseInt(sessionStorage.getItem(`${this.sleeknoteId}_triggered`)) || 0;
        
    if (this.checkEligibility()) {      
      setTimeout(() => {
        if (this.triggeredCount < this.limitPerSession) {
          this.triggerSleekNotePopup();
        }
      }, this.delay * 1000);
    }
  }
  
  disconnectedCallback() {}
  
  checkEligibility() {
    let isEligible = this.liquidEligible;

    if (this.campaignCodeCheck) {
      const campaignCodeEl = document.querySelector('[data-copy].dynamic-campaign-code');
      if (campaignCodeEl) isEligible = false;
    }
    
    if (this.bundleBadgeCheck) {
      const bundleBadgeEl = document.querySelector('.bundle-badge');
      if (bundleBadgeEl) isEligible = false;
    }
    
    if (this.disallowedUtmValues) {
      const utmParams = new URLSearchParams(window.location.search);
      if (utmParams.has('utm_source')) {
        const utmSource = utmParams.get('utm_source');
        for (const disallowedUtmValue of this.disallowedUtmValues) {
          if (utmSource == disallowedUtmValue) { 
            isEligible = false;
          }
        }
      }
    }
    
    return isEligible;
  }
  
  loadSleekNoteScript() {
    return new Promise((resolve, reject) => {
      if (window.SleekNote) {
        resolve(window.SleekNote);
      }
      
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.charset = 'utf-8';
      script.src = '//sleeknotecustomerscripts.sleeknote.com/31.js';
      
      script.onload = () => {
        if (window.SleekNote?.triggerOnClick) {
          resolve(window.SleekNote);
        } else {
          reject(new Error('SleekNote failed to initialize'));
        }
      };
      
      script.onerror = () => {
        reject(new Error('Failed to load SleekNote script'));
      };
      
      const currentScript = document.getElementById('sleeknoteScript');
      currentScript.parentNode.insertBefore(script, currentScript);
    });
  }
  
  async triggerSleekNotePopup() {
    try {
      const sleekNote = await this.loadSleekNoteScript();
      sleekNote.triggerOnClick(this.sleeknoteId);
      sessionStorage.setItem(`${this.sleeknoteId}_triggered`, this.triggeredCount + 1);
      
      console.log('SleekNote popup triggered', this.sleeknoteId);
    } catch (error) {
      console.warn('SleekNote popup failed to load:', error.message);
    }
  };
}

customElements.define('sleeknote-popup', SleeknotePopup);
  } catch(e) { console.error(e); }
})();

})();
